import { createSlice } from '@reduxjs/toolkit'
import { fetchAllBanners } from 'redux-thunk/thunk/banner.thunk'

const initialState = {
  banners: [],
  loading: false,
  error: null,
}

const bannerSlice = createSlice({
  name: 'banner',
  initialState,
  reducers: {
    clearBannerState: (state) => {
      // Reset state properties explicitly to avoid reference issues
      state.banners = []
      state.loading = false
      state.error = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllBanners.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchAllBanners.fulfilled, (state, action) => {
        state.loading = false
        state.banners = action.payload
      })
      .addCase(fetchAllBanners.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
  },
})

export const { clearBannerState } = bannerSlice.actions
export default bannerSlice.reducer
